import { DLFormStartEvent } from "../DLEvents"
import { DLFormStartEventParent } from "../DLEvents/DLFormEvent"

export const handleClickForm = () => {
  DLFormStartEvent({ placement: "main" })
}

export const handleClickFormParent = () => {
  DLFormStartEventParent({ placement: "main" })
}
